export default "__VITE_ASSET__DX3xQB$6__"